import UsersPage from './UsersPage'
import { usersMenu } from './sideBarOption'

export { usersMenu }
export default UsersPage
